import debounce from 'lodash-es/debounce'
import { useEffect, useLayoutEffect, useMemo, useRef } from 'react'

// oxlint-disable-next-line @typescript-eslint/no-explicit-any, max-params
export const useDebounceCallback = <T extends (...params: any) => any>(
  callback: T,
  delay: number,
  dependencies: unknown[] = [],
) => {
  const callbackRef = useRef(callback)

  useLayoutEffect(() => {
    callbackRef.current = callback
  })

  const debouncedCallback = useMemo(
    () =>
      debounce((...args: Parameters<T>) => callbackRef.current(...args), delay),
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    [delay, ...dependencies],
  )

  useEffect(() => () => debouncedCallback.cancel(), [debouncedCallback])

  return debouncedCallback
}
